import { createFileRoute } from "@tanstack/react-router";

import FriendsPage from "~/pages/friends/FriendsPage.tsx";

export const Route = createFileRoute("/_auth/friends/")({
    component: FriendsPage,
});
